import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ZagButton } from '../button/button';
import { Checkbox } from '../checkbox/checkbox';

@Component({
  selector: 'zag-selection-toolbar',
  imports: [FormsModule, TranslatePipe, ZagButton, Checkbox],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="zag-selection-toolbar" role="region" [attr.aria-label]="'common.selectionMode' | translate">
      <div class="zag-selection-toolbar__summary">
        <div class="zag-selection-toolbar__all-matching">
          <zag-checkbox
            [label]="'common.selectAllMatching' | translate"
            [ngModel]="allMatchingActive()"
            (ngModelChange)="selectAllMatching.emit($event)"
          />
          <span class="zag-selection-toolbar__count">
            {{ 'common.selectedCount' | translate: { selected: selectedCount(), total: totalCount() } }}
          </span>
        </div>
      </div>

      <div class="zag-selection-toolbar__actions">
        <button zagButton type="button" zagType="primary" [disabled]="selectedCount() === 0" (click)="bulkEdit.emit()">
          {{ 'common.bulkEdit' | translate }}…
        </button>
        <button zagButton="outlined" zagType="secondary" type="button" (click)="cancelSelection.emit()">
          {{ 'common.cancelSelection' | translate }}
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        position: sticky;
        bottom: 0;
        z-index: var(--z-index-selection-toolbar);
        width: 100%;
      }

      .zag-selection-toolbar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: var(--spacing-md);
        padding: var(--spacing-sm) var(--spacing-md);
        background-color: var(--color-selection-toolbar-surface);
        box-shadow: var(--elevation-selection-toolbar);
        border-top: var(--border-width-default) solid var(--border-color-default);
      }

      .zag-selection-toolbar__summary {
        display: flex;
        align-items: center;
        gap: var(--spacing-sm);
      }

      .zag-selection-toolbar__all-matching {
        display: flex;
        align-items: center;
        gap: var(--spacing-xs);
        cursor: pointer;
        font-size: var(--font-size-sm);
        color: var(--text-color-primary);
      }

      .zag-selection-toolbar__count {
        font-weight: var(--font-weight-medium);
      }

      .zag-selection-toolbar__actions {
        display: flex;
        align-items: center;
        gap: var(--spacing-sm);
      }
    `,
  ],
})
export class SelectionToolbarComponent {
  readonly selectedCount = input.required<number>();
  readonly totalCount = input.required<number>();
  readonly allMatchingActive = input<boolean>(false);

  readonly selectAllMatching = output<boolean>();
  readonly bulkEdit = output<void>();
  readonly cancelSelection = output<void>();
}
